/*
 * Horizontal rule component
 */

import React from 'react';

import Base from './base.jsx'; 
import { Mode } from '../common.jsx';
import Select from '../../common/Select.jsx';
export default class HorizontalRule extends Base {

        static defaultContent(language) {
            return Object.assign(super.defaultContent(language), {
                stroke: 1,
                color: '#2d2d31'
            });
        }

        static get CATEGORY() {
            return 'layout';
        }

        static get TYPE() {
            return 'hr';
        }

        static icon(){
            return <i className="fa fa-minus"></i>;
        }

        constructor(props){
            super(props);
            this.updateStroke = this.updateStroke.bind(this);
            this.initPickers = this.initPickers.bind(this);
            this.updateColor = this.updateColor.bind(this);
        }

        renderView() {
            return (
                <hr style={{borderTop: `${this.props.content.stroke}px solid ${this.props.content.color}`}} />
            );
        }

        renderSettings() {
            let strokeOptions = Array.from({length: 10}, (_, i) => i + 1).map((d) => {
                return ({
                    label: d,
                    value: d
                });
            });

            return(
                <div>
                    <p>{I18n.t('horizontal_rule_description')}</p>
                    <div className="setting">
                        <label>{I18n.t('color')}</label>
                        <div className="input-group colorpicker-component">
                            <input type="text" className="form-control color-picker-input" name="color" defaultValue={this.props.content.color} onChange={this.updateSettings} autoComplete={this.getAutoComplete()} />
                            <span className="input-group-addon" onClick={() => jQuery('.color-picker-input').focus()}>
                                <i style={{ backgroundColor: this.props.content.color }}></i>
                            </span>
                        </div>
                    </div>
                    <div className="setting">
                        <label>{I18n.t('stroke', {scope: 'fe'})}</label>
                        <div className="checkbox-list">
                            <Select className="multi-select-dropdown"                         
                                    value={this.props.content.stroke}
                                    onChange={this.updateStroke}
                                    options={strokeOptions}
                                    formatOptionLabel={({ value }) => {
                                        return (
                                            <span>
                                                <hr style={{borderTop: `${value}px solid black`}} />
                                            </span>
                                        );
                                    }}
                                    name="stroke"
                                    autoComplete={this.getAutoComplete()}
                                    > 
                            </Select>
                        </div>
                    </div>
                </div>
            )
        }

        componentDidMount() {
            super.componentDidMount();
            if (this.props.mode == Mode.SETTINGS) {
                jQuery('.settings').css('overflow', 'unset')
                this.initPickers();
            }
        }

        updateStroke(event) {
            let content = JSON.parse(JSON.stringify(this.props.content));
            content['stroke'] = event;
            this.props.updateSettingsCallback(content.id, content, true);
        }

        updateColor(event) {
            let content = JSON.parse(JSON.stringify(this.props.content));
            content['color'] = event.target.value;
            this.props.updateSettingsCallback(content.id, content, true);
        }

        initPickers() {
            jQuery(".colorpicker-component").not(".colorpicker-element").colorpicker();
            jQuery(".colorpicker-component .color-picker-input").off("blur").on("blur", this.updateColor);
          }
}
